import { useCurrentClient } from '@pbk-web/state';
import type { ModuleType } from '@pbk-web/types';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import ClientTemplateModuleService from '../services/ClientTemplateModuleService';

export const useFetchModules = (types: ModuleType[]) => {
  const currentClient = useCurrentClient((x) => x.value);

  const service = useMemo(() => currentClient && new ClientTemplateModuleService(currentClient.id), [currentClient]);

  return useQuery({
    queryKey: ['modules', currentClient?.id, { types }],
    staleTime: 5 * 60 * 1000, // 5 minutes
    queryFn: async () => {
      return service!.getTemplates(false, true, types).then((res) => res.data);
    },
    enabled: !!currentClient?.id,
  });
};
